/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
import type { IBrand, IImage } from '@/common/interfaces/shopify.interface';

export interface Filter {
  id: string;
  name: string;
  rank: number;
  isSelected?: boolean;
}

export interface Color {
  id: string;
  code: string;
  rank: number;
  name?: string;
}

export interface ColorFilters {
  [key: string]: Color[];
}

export interface ColorNameMap {
  [key: string]: string;
}

export interface Variant {
  code: string;
  name: string;
  imgUrl: string;
  location: string;
  images?: IImage[];
}

export interface Product {
  id: number;
  name: string;
  brand: IBrand;
  color: Color;
  flashEligible: boolean;
  category: string;
  imgUrl: string;
  tags: string[];
  rating: number;
  styleCode: string;
  budgetTag?: string;
  noOfSkus?: string | number;
  variants?: Variant[];
}

export interface ProductData {
  page: Product[];
}

export interface ProductsResponse {
  count: number;
  page: Product[];
  currentArgs: any;
}

export const FilterMainColors: Color[] = [
  { id: 'White', code: '#FFFFFF', rank: 10 },
  { id: 'Gray', code: '#D5D5D5', rank: 20 },
  { id: 'Black', code: '#000000', rank: 30 },
  { id: 'Red', code: '#FF2B2B', rank: 40 },
  { id: 'Brown', code: '#8B4612', rank: 50 },
  { id: 'Orange', code: '#FF9800', rank: 60 },
  { id: 'Yellow', code: '#FFEB3B', rank: 70 },
  { id: 'Green', code: '#0EA70E', rank: 80 },
  { id: 'Blue', code: '#2149C3', rank: 90 },
  { id: 'Purple', code: '#7F13FF', rank: 100 },
  { id: 'Pink', code: '#FF68BA', rank: 110 },
];

export interface Filters {
  types: Filter[];
  brands: Filter[];
  allBrands: Filter[];
  style: Filter[];
  madeFor: Filter[];
  price: Filter[];
  season: Filter[];
}

export const PRODUCT_FILTERS: Filters = {
  types: [
    {
      id: 'Shirts',
      name: 'Shirts',
      rank: 10,
    },
    {
      id: 'Sweaters',
      name: 'Sweaters',
      rank: 20,
    },
    {
      id: 'Bottoms',
      name: 'Bottoms',
      rank: 30,
    },
    {
      id: 'Accessories',
      name: 'Accessories',
      rank: 40,
    },
    {
      id: 'Hats',
      name: 'Hats',
      rank: 50,
    },
    {
      id: 'Tanks',
      name: 'Tanks',
      rank: 60,
    },
    {
      id: 'Jackets',
      name: 'Jackets',
      rank: 70,
    },
    {
      id: 'Jerseys',
      name: 'Jerseys',
      rank: 80,
    },
    {
      id: 'Polos',
      name: 'Polos',
      rank: 90,
    },
  ],
  brands: [
    {
      id: 'Fresh Prints',
      name: 'Fresh Prints',
      rank: 50,
    },
    {
      id: 'Comfort Colors',
      name: 'Comfort Colors',
      rank: 10,
    },
    {
      id: 'Champion',
      name: 'Champion',
      rank: 20,
    },
    {
      id: 'Nike',
      name: 'Nike',
      rank: 30,
    },
    {
      id: 'Charles River',
      name: 'Charles River',
      rank: 40,
    },
    {
      id: 'Gildan',
      name: 'Gildan',
      rank: 60,
    },
    {
      id: 'Adidas',
      name: 'Adidas',
      rank: 70,
    },
    {
      id: 'Adams',
      name: 'Adams',
      rank: 80,
    },
    {
      id: 'Bella + Canvas',
      name: 'Bella + Canvas',
      rank: 90,
    },
    {
      id: 'Augusta',
      name: 'Augusta',
      rank: 100,
    },
    {
      id: 'District',
      name: 'District',
      rank: 110,
    },
    {
      id: 'Tie-Dye',
      name: 'Tie-Dye',
      rank: 120,
    },
    {
      id: 'Independent Trading Co.',
      name: 'Independent Trading Co.',
      rank: 130,
    },
    {
      id: 'DC',
      name: 'DC',
      rank: 140,
    },
    {
      id: 'The North Face',
      name: 'The North Face',
      rank: 150,
    },
    {
      id: 'Dyenomite',
      name: 'Dyenomite',
      rank: 160,
    },
    {
      id: 'Alternative',
      name: 'Alternative',
      rank: 170,
    },
    {
      id: 'H&D',
      name: 'H&D',
      rank: 180,
    },
    {
      id: 'Vineyard Vines',
      name: 'Vineyard Vines',
      rank: 190,
    },
    {
      id: 'Big Accessories',
      name: 'Big Accessories',
      rank: 200,
    },
    {
      id: 'Blank Hockey Jerseys',
      name: 'Blank Hockey Jerseys',
      rank: 210,
    },
    {
      id: 'Columbia',
      name: 'Columbia',
      rank: 220,
    },
    {
      id: 'Southern Tide',
      name: 'Southern Tide',
      rank: 230,
    },
    {
      id: 'Boxercraft',
      name: 'Boxercraft',
      rank: 240,
    },
    {
      id: 'Sportsman',
      name: 'Sportsman',
      rank: 250,
    },
    {
      id: 'Just Hoods By AWDis',
      name: 'Just Hoods By AWDis',
      rank: 260,
    },
    {
      id: 'Tiedyeusa',
      name: 'Tiedyeusa',
      rank: 270,
    },
    {
      id: 'Hardware',
      name: 'Hardware',
      rank: 280,
    },
    {
      id: 'The Game',
      name: 'The Game',
      rank: 290,
    },
    {
      id: 'Jakprints',
      name: 'Jakprints',
      rank: 300,
    },
    {
      id: 'Threadfast',
      name: 'Threadfast',
      rank: 310,
    },
    {
      id: 'HYFVE',
      name: 'HYFVE',
      rank: 320,
    },
    {
      id: 'Port & Company',
      name: 'Port & Company',
      rank: 330,
    },
    {
      id: 'Next Level',
      name: 'Next Level',
      rank: 340,
    },
    {
      id: 'Badger',
      name: 'Badger',
      rank: 350,
    },
    {
      id: 'Puma',
      name: 'Puma',
      rank: 360,
    },
    {
      id: 'Flextfit',
      name: 'Flextfit',
      rank: 370,
    },
    {
      id: 'Sport-Tek',
      name: 'Sport-Tek',
      rank: 380,
    },
    {
      id: 'Carhartt',
      name: 'Carhartt',
      rank: 390,
    },
    {
      id: 'Very Berry',
      name: 'Very Berry',
      rank: 400,
    },
    {
      id: 'Aaron & Amber',
      name: 'Aaron & Amber',
      rank: 410,
    },
    {
      id: 'Fashion Bridge',
      name: 'Fashion Bridge',
      rank: 420,
    },
    {
      id: '11 Degrees',
      name: '11 Degrees',
      rank: 430,
    },
    {
      id: 'Under Armour',
      name: 'Under Armour',
      rank: 440,
    },
    {
      id: 'Pennant',
      name: 'Pennant',
      rank: 450,
    },
    {
      id: 'Omnicheer',
      name: 'Omnicheer',
      rank: 460,
    },
    {
      id: 'Authentic Pigment',
      name: 'Authentic Pigment',
      rank: 470,
    },
    {
      id: 'Ash City',
      name: 'Ash City',
      rank: 480,
    },
    {
      id: 'North End',
      name: 'North End',
      rank: 490,
    },
    {
      id: 'UltraClub',
      name: 'UltraClub',
      rank: 500,
    },
    {
      id: 'US Blanks',
      name: 'US Blanks',
      rank: 510,
    },
    {
      id: 'Team 365',
      name: 'Team 365',
      rank: 520,
    },
    {
      id: 'Shaka Wear',
      name: 'Shaka Wear',
      rank: 530,
    },
    {
      id: 'Hanes',
      name: 'Hanes',
      rank: 540,
    },
    {
      id: 'A4',
      name: 'A4',
      rank: 550,
    },
    {
      id: 'Harriton',
      name: 'Harriton',
      rank: 560,
    },
    {
      id: 'econscious',
      name: 'econscious',
      rank: 570,
    },
    {
      id: 'BAGedge',
      name: 'BAGedge',
      rank: 580,
    },
    {
      id: 'J America',
      name: 'J America',
      rank: 590,
    },
    {
      id: 'Liberty Bags',
      name: 'Liberty Bags',
      rank: 600,
    },
    {
      id: 'LAT',
      name: 'LAT',
      rank: 610,
    },
    {
      id: 'Jerzees',
      name: 'Jerzees',
      rank: 620,
    },
    {
      id: 'Fruit of the Loom',
      name: 'Fruit of the Loom',
      rank: 630,
    },
    {
      id: 'DRI DUCK',
      name: 'DRI DUCK',
      rank: 640,
    },
    {
      id: 'Alleson Athletic',
      name: 'Alleson Athletic',
      rank: 650,
    },
    {
      id: 'Alstyle',
      name: 'Alstyle',
      rank: 660,
    },
    {
      id: 'American Apparel',
      name: 'American Apparel',
      rank: 670,
    },
    {
      id: 'Anvil',
      name: 'Anvil',
      rank: 680,
    },
    {
      id: 'Valucap',
      name: 'Valucap',
      rank: 690,
    },
    {
      id: 'Flexfit',
      name: 'Flexfit',
      rank: 700,
    },
    {
      id: 'Yupoong',
      name: 'Yupoong',
      rank: 710,
    },
    {
      id: 'YETI',
      name: 'YETI',
      rank: 720,
    },
    {
      id: "Arc'teryx",
      name: "Arc'teryx",
      rank: 730,
    },
    {
      id: 'Lacoste',
      name: 'Lacoste',
      rank: 740,
    },
    {
      id: 'STATE Bags',
      name: 'STATE Bags',
      rank: 750,
    },
    {
      id: 'Eddie Bauer',
      name: 'Eddie Bauer',
      rank: 760,
    },
    {
      id: 'Peter Millar',
      name: 'Peter Millar',
      rank: 770,
    },
    {
      id: 'OtterBox',
      name: 'OtterBox',
      rank: 780,
    },
    {
      id: 'Corkcicle',
      name: 'Corkcicle',
      rank: 790,
    },
    {
      id: 'OGIO',
      name: 'OGIO',
      rank: 800,
    },
    {
      id: 'Nalgene',
      name: 'Nalgene',
      rank: 810,
    },
    {
      id: 'Marine Layer',
      name: 'Marine Layer',
      rank: 820,
    },
    {
      id: 'Hamilton Perkins Collection',
      name: 'Hamilton Perkins Collection',
      rank: 830,
    },
    {
      id: 'FeatherLite',
      name: 'FeatherLite',
      rank: 840,
    },
    {
      id: 'Sierra Pacific',
      name: 'Sierra Pacific',
      rank: 850,
    },
  ],
  allBrands: [
    {
      id: 'Fresh Prints',
      name: 'Fresh Prints',
      rank: 50,
    },
    {
      id: 'Comfort Colors',
      name: 'Comfort Colors',
      rank: 10,
    },
    {
      id: 'Champion',
      name: 'Champion',
      rank: 20,
    },
    {
      id: 'Nike',
      name: 'Nike',
      rank: 30,
    },
    {
      id: 'Charles River',
      name: 'Charles River',
      rank: 40,
    },
  ],
  style: [
    {
      id: 'Casual',
      name: 'Casual',
      rank: 10,
    },
    {
      id: 'Classic',
      name: 'Classic',
      rank: 20,
    },
    {
      id: 'Game Day',
      name: 'Game Day',
      rank: 30,
    },
    {
      id: 'Preppy',
      name: 'Preppy',
      rank: 40,
    },
    {
      id: 'Cozy',
      name: 'Cozy',
      rank: 50,
    },
    {
      id: 'Athleisure',
      name: 'Athleisure',
      rank: 60,
    },
    {
      id: 'Outdoorsy',
      name: 'Outdoorsy',
      rank: 70,
    },
    {
      id: 'Sportswear',
      name: 'Sportswear',
      rank: 80,
    },
    {
      id: 'Festival',
      name: 'Festival',
      rank: 90,
    },
    {
      id: 'Tie Dye',
      name: 'Tie Dye',
      rank: 100,
    },
    {
      id: 'Corded',
      name: 'Corded',
      rank: 110,
    },
    {
      id: 'Street',
      name: 'Street',
      rank: 120,
    },
    {
      id: 'Professional',
      name: 'Professional',
      rank: 130,
    },
    {
      id: 'Going Out',
      name: 'Going Out',
      rank: 140,
    },
    {
      id: 'Neon',
      name: 'Neon',
      rank: 150,
    },
    {
      id: 'Color Block',
      name: 'Color Block',
      rank: 160,
    },
    {
      id: 'Clean Streetwear',
      name: 'Clean Streetwear',
      rank: 170,
    },
    {
      id: '80s/90s',
      name: '80s/90s',
      rank: 180,
    },
    {
      id: 'Pastels',
      name: 'Pastels',
      rank: 190,
    },
    {
      id: 'Minimalist',
      name: 'Minimalist',
      rank: 200,
    },
    {
      id: 'Athletic',
      name: 'Athletic',
      rank: 210,
    },
    {
      id: 'Grunge Streetwear',
      name: 'Grunge Streetwear',
      rank: 220,
    },
  ],
  madeFor: [
    {
      id: 'Unisex',
      name: 'Unisex',
      rank: 10,
    },
    {
      id: 'Women',
      name: 'Women',
      rank: 20,
    },
    {
      id: 'Men',
      name: 'Men',
      rank: 30,
    },
    {
      id: 'Youth',
      name: 'Youth',
      rank: 40,
    },
  ],
  price: [
    {
      id: '$',
      name: '$',
      rank: 10,
    },
    {
      id: '$$',
      name: '$$',
      rank: 20,
    },
    {
      id: '$$$',
      name: '$$$',
      rank: 30,
    },
  ],
  season: [
    {
      id: 'Fall',
      name: 'Fall',
      rank: 10,
    },
    {
      id: 'Winter',
      name: 'Winter',
      rank: 20,
    },
    {
      id: 'Spring',
      name: 'Spring',
      rank: 30,
    },
    {
      id: 'Summer',
      name: 'Summer',
      rank: 40,
    },
  ],
};

export const FILTERSWITHSELECTION: Filters = {
  types: PRODUCT_FILTERS.types.map((item) => ({ ...item, isSelected: false })),
  brands: PRODUCT_FILTERS.brands.map((item) => ({ ...item, isSelected: false })),
  allBrands: PRODUCT_FILTERS.brands.map((item) => ({ ...item, isSelected: false })),
  style: PRODUCT_FILTERS.style.map((item) => ({ ...item, isSelected: false })),
  madeFor: PRODUCT_FILTERS.madeFor.map((item) => ({ ...item, isSelected: false })),
  price: PRODUCT_FILTERS.price.map((item) => ({ ...item, isSelected: false })),
  season: PRODUCT_FILTERS.season.map((item) => ({ ...item, isSelected: false })),
};

export const PROD_COLORS: ColorFilters = {
  White: [
    {
      id: '#ffffff',
      code: '#ffffff',
      rank: 10,
    },
    {
      id: '#f7f7f7',
      code: '#f7f7f7',
      rank: 20,
    },
    {
      id: '#f3f3f2',
      code: '#f3f3f2',
      rank: 30,
    },
    {
      id: '#f2f0ef',
      code: '#f2f0ef',
      rank: 40,
    },
    {
      id: '#eeeeee',
      code: '#eeeeee',
      rank: 50,
    },
    {
      id: '#ecedef',
      code: '#ecedef',
      rank: 60,
    },
    {
      id: '#ebebed',
      code: '#ebebed',
      rank: 70,
    },
    {
      id: '#eceae8',
      code: '#eceae8',
      rank: 80,
    },
    {
      id: '#eae8ea',
      code: '#eae8ea',
      rank: 90,
    },
    {
      id: '#e6e8e7',
      code: '#e6e8e7',
      rank: 100,
    },
    {
      id: '#e9e5e5',
      code: '#e9e5e5',
      rank: 110,
    },
    {
      id: '#e4e5e9',
      code: '#e4e5e9',
      rank: 120,
    },
  ],
  Gray: [
    {
      id: '#e4e4e4',
      code: '#e4e4e4',
      rank: 10,
    },
    {
      id: '#a4a7b0',
      code: '#a4a7b0',
      rank: 20,
    },
    {
      id: '#999795',
      code: '#999795',
      rank: 30,
    },
    {
      id: '#8a838b',
      code: '#8a838b',
      rank: 40,
    },
    {
      id: '#7d746b',
      code: '#7d746b',
      rank: 50,
    },
    {
      id: '#636579',
      code: '#636579',
      rank: 60,
    },
    {
      id: '#5a595e',
      code: '#5a595e',
      rank: 70,
    },
    {
      id: '#4b4c50',
      code: '#4b4c50',
      rank: 80,
    },
    {
      id: '#434238',
      code: '#434238',
      rank: 90,
    },
    {
      id: '#383637',
      code: '#383637',
      rank: 100,
    },
    {
      id: '#2b2c2c',
      code: '#2b2c2c',
      rank: 110,
    },
    {
      id: '#242021',
      code: '#242021',
      rank: 120,
    },
  ],
  Black: [
    {
      id: '#000102',
      code: '#000102',
      rank: 10,
    },
    {
      id: '#000000',
      code: '#000000',
      rank: 20,
    },
  ],
  Red: [
    {
      id: '#fdf4f5',
      code: '#fdf4f5',
      rank: 10,
    },
    {
      id: '#f5b1b0',
      code: '#f5b1b0',
      rank: 20,
    },
    {
      id: '#cd8b90',
      code: '#cd8b90',
      rank: 30,
    },
    {
      id: '#f65a7f',
      code: '#f65a7f',
      rank: 40,
    },
    {
      id: '#ef4b32',
      code: '#ef4b32',
      rank: 50,
    },
    {
      id: '#c64250',
      code: '#c64250',
      rank: 60,
    },
    {
      id: '#db243b',
      code: '#db243b',
      rank: 70,
    },
    {
      id: '#e7132f',
      code: '#e7132f',
      rank: 80,
    },
    {
      id: '#88353c',
      code: '#88353c',
      rank: 90,
    },
    {
      id: '#ae1b2a',
      code: '#ae1b2a',
      rank: 100,
    },
    {
      id: '#6d2e37',
      code: '#6d2e37',
      rank: 110,
    },
    {
      id: '#572932',
      code: '#572932',
      rank: 120,
    },
  ],
  Brown: [
    {
      id: '#fefdf9',
      code: '#fefdf9',
      rank: 10,
    },
    {
      id: '#e6e2d6',
      code: '#e6e2d6',
      rank: 20,
    },
    {
      id: '#f4d1a1',
      code: '#f4d1a1',
      rank: 30,
    },
    {
      id: '#d0cec1',
      code: '#d0cec1',
      rank: 40,
    },
    {
      id: '#ebc057',
      code: '#ebc057',
      rank: 50,
    },
    {
      id: '#d0b48c',
      code: '#d0b48c',
      rank: 60,
    },
    {
      id: '#b2a89c',
      code: '#b2a89c',
      rank: 70,
    },
    {
      id: '#a59886',
      code: '#a59886',
      rank: 80,
    },
    {
      id: '#f15e29',
      code: '#f15e29',
      rank: 90,
    },
    {
      id: '#7b755e',
      code: '#7b755e',
      rank: 100,
    },
    {
      id: '#9a5415',
      code: '#9a5415',
      rank: 110,
    },
    {
      id: '#524b38',
      code: '#524b38',
      rank: 120,
    },
  ],
  Orange: [
    {
      id: '#fff5e8',
      code: '#fff5e8',
      rank: 10,
    },
    {
      id: '#fab45e',
      code: '#fab45e',
      rank: 20,
    },
    {
      id: '#ff9966',
      code: '#ff9966',
      rank: 30,
    },
    {
      id: '#f89a49',
      code: '#f89a49',
      rank: 40,
    },
    {
      id: '#ff8f1c',
      code: '#ff8f1c',
      rank: 50,
    },
    {
      id: '#fe7940',
      code: '#fe7940',
      rank: 60,
    },
    {
      id: '#fc7f01',
      code: '#fc7f01',
      rank: 70,
    },
    {
      id: '#f6742e',
      code: '#f6742e',
      rank: 80,
    },
    {
      id: '#fb6b24',
      code: '#fb6b24',
      rank: 90,
    },
    {
      id: '#ff6717',
      code: '#ff6717',
      rank: 100,
    },
    {
      id: '#ff5e0d',
      code: '#ff5e0d',
      rank: 110,
    },
    {
      id: '#fd4f06',
      code: '#fd4f06',
      rank: 120,
    },
  ],
  Yellow: [
    {
      id: '#fceec5',
      code: '#fceec5',
      rank: 10,
    },
    {
      id: '#fee7a1',
      code: '#fee7a1',
      rank: 20,
    },
    {
      id: '#ffdc72',
      code: '#ffdc72',
      rank: 30,
    },
    {
      id: '#ffd733',
      code: '#ffd733',
      rank: 40,
    },
    {
      id: '#ffda03',
      code: '#ffda03',
      rank: 50,
    },
    {
      id: '#ffd501',
      code: '#ffd501',
      rank: 60,
    },
    {
      id: '#fece01',
      code: '#fece01',
      rank: 70,
    },
    {
      id: '#ffb549',
      code: '#ffb549',
      rank: 80,
    },
    {
      id: '#ffb907',
      code: '#ffb907',
      rank: 90,
    },
    {
      id: '#ffb300',
      code: '#ffb300',
      rank: 100,
    },
    {
      id: '#f5a60c',
      code: '#f5a60c',
      rank: 110,
    },
    {
      id: '#eaa402',
      code: '#eaa402',
      rank: 120,
    },
  ],
  Green: [
    {
      id: '#fcfffc',
      code: '#fcfffc',
      rank: 10,
    },
    {
      id: '#e5ec5d',
      code: '#e5ec5d',
      rank: 20,
    },
    {
      id: '#e7e41b',
      code: '#e7e41b',
      rank: 30,
    },
    {
      id: '#a9d6b9',
      code: '#a9d6b9',
      rank: 40,
    },
    {
      id: '#b2d234',
      code: '#b2d234',
      rank: 50,
    },
    {
      id: '#93a8a3',
      code: '#93a8a3',
      rank: 60,
    },
    {
      id: '#888968',
      code: '#888968',
      rank: 70,
    },
    {
      id: '#4e7b65',
      code: '#4e7b65',
      rank: 80,
    },
    {
      id: '#5a5f3a',
      code: '#5a5f3a',
      rank: 90,
    },
    {
      id: '#51503d',
      code: '#51503d',
      rank: 100,
    },
    {
      id: '#424532',
      code: '#424532',
      rank: 110,
    },
    {
      id: '#333e1d',
      code: '#333e1d',
      rank: 120,
    },
  ],
  Blue: [
    {
      id: '#fcfdff',
      code: '#fcfdff',
      rank: 10,
    },
    {
      id: '#b9d9eb',
      code: '#b9d9eb',
      rank: 20,
    },
    {
      id: '#a7bcd6',
      code: '#a7bcd6',
      rank: 30,
    },
    {
      id: '#7a9eaf',
      code: '#7a9eaf',
      rank: 40,
    },
    {
      id: '#06b1b0',
      code: '#06b1b0',
      rank: 50,
    },
    {
      id: '#4d6995',
      code: '#4d6995',
      rank: 60,
    },
    {
      id: '#425877',
      code: '#425877',
      rank: 70,
    },
    {
      id: '#234e93',
      code: '#234e93',
      rank: 80,
    },
    {
      id: '#0c46aa',
      code: '#0c46aa',
      rank: 90,
    },
    {
      id: '#3c2b72',
      code: '#3c2b72',
      rank: 100,
    },
    {
      id: '#2a2f42',
      code: '#2a2f42',
      rank: 110,
    },
    {
      id: '#192a3c',
      code: '#192a3c',
      rank: 120,
    },
  ],
  Purple: [
    {
      id: '#f8f6f9',
      code: '#f8f6f9',
      rank: 10,
    },
    {
      id: '#e3e0e6',
      code: '#e3e0e6',
      rank: 20,
    },
    {
      id: '#cac8cb',
      code: '#cac8cb',
      rank: 30,
    },
    {
      id: '#c8b4cd',
      code: '#c8b4cd',
      rank: 40,
    },
    {
      id: '#b3a8c8',
      code: '#b3a8c8',
      rank: 50,
    },
    {
      id: '#9042eb',
      code: '#9042eb',
      rank: 60,
    },
    {
      id: '#614b79',
      code: '#614b79',
      rank: 70,
    },
    {
      id: '#613081',
      code: '#613081',
      rank: 80,
    },
    {
      id: '#4f2d7a',
      code: '#4f2d7a',
      rank: 90,
    },
    {
      id: '#412c67',
      code: '#412c67',
      rank: 100,
    },
    {
      id: '#431e64',
      code: '#431e64',
      rank: 110,
    },
    {
      id: '#3c0d6a',
      code: '#3c0d6a',
      rank: 120,
    },
  ],
  Pink: [
    {
      id: '#fffbfc',
      code: '#fffbfc',
      rank: 10,
    },
    {
      id: '#edced7',
      code: '#edced7',
      rank: 20,
    },
    {
      id: '#ddbad0',
      code: '#ddbad0',
      rank: 30,
    },
    {
      id: '#ff83af',
      code: '#ff83af',
      rank: 40,
    },
    {
      id: '#a88aa4',
      code: '#a88aa4',
      rank: 50,
    },
    {
      id: '#f54b88',
      code: '#f54b88',
      rank: 60,
    },
    {
      id: '#db37a8',
      code: '#db37a8',
      rank: 70,
    },
    {
      id: '#c63156',
      code: '#c63156',
      rank: 80,
    },
    {
      id: '#694553',
      code: '#694553',
      rank: 90,
    },
    {
      id: '#a4123f',
      code: '#a4123f',
      rank: 100,
    },
    {
      id: '#ad0132',
      code: '#ad0132',
      rank: 110,
    },
    {
      id: '#531c2f',
      code: '#531c2f',
      rank: 120,
    },
  ],
};

export const displayFliterNameMap: ColorNameMap = {
  madeFor: 'Made for',
  types: 'Type',
  style: 'Styles',
  season: 'Season',
  price: 'Price',
  brands: 'Brands',
};

export interface FilterState {
  types: string[];
  brands: string[];
  style: string[];
  madeFor: string[];
  season: string[];
  price: string[];
  color: string[];
  tags: string[];
  colorHex: string;
  options: Filters;
  openGallery: boolean;
  selectedProduct: Product;
  searchText: string;
  filterSearchParams: string;
  pageNum: number;
  showMobileFilters: boolean;
  mobileFiltersApplied: boolean;
}

export const parseGalleryFilters = (filtersState: FilterState) => {
  const params = [];
  let filterParams = '';

  const mainGalleryFilters: (keyof FilterState)[] = [
    'types',
    'brands',
    'style',
    'madeFor',
    'season',
    'price',
  ];

  mainGalleryFilters.forEach((key) => {
    const currentValue = filtersState[key];

    if (Array.isArray(currentValue) && currentValue.length > 0) {
      if (filterParams !== '') filterParams += ';';
      filterParams += `${
        key === 'types' || key === 'brands' ? key.slice(0, -1) : key
      }:${currentValue.join(',')}`;
    }
  });

  if (filterParams?.length) {
    params.push(`filters=${encodeURIComponent(filterParams)}`);
  }

  if (filtersState.colorHex.length || filtersState.color.length) {
    const colorParam = filtersState?.colorHex?.trim() || filtersState.color[0];

    if (colorParam) {
      params.push(`color=${encodeURIComponent(colorParam)}`);
    }
  }

  if (filtersState.searchText) {
    params.push(`search=${encodeURIComponent(filtersState.searchText)}`);
  }

  return params.join('&');
};

/** To get the unique variants and prioritze the 'Front' location variant incase if there is one */
export const getUniqueVariants = (inputArray: Variant[]): Record<string, Variant> =>
  inputArray.reduce((acc: Record<string, Variant>, item: Variant) => {
    if (!acc[item.code] || item.location === 'Front') {
      acc[item.code] = item;
    }
    return acc;
  }, {});
